module.exports = __webpack_public_path__ + "img/PT274.d83e4802.png";